<template>
  <div class="alb-page">
    <div class="sub-nav">
      <a href="#/" class="sub-nav-back">← 返回首页</a>
      <span class="sub-nav-title">云相册</span>
    </div>

    <section class="alb-head">
      <div class="alb-head-tag">
        <span class="alb-head-line"></span>
        CLOUD ALBUM
        <span class="alb-head-line"></span>
      </div>
      <h1 class="alb-head-title">云相册</h1>
      <p class="alb-head-desc">线上同步开幕盛况，足不出户见证启幕时刻</p>
    </section>

    <section class="alb-body">
      <div class="alb-entry">
        <div class="alb-entry-icon">🎥</div>
        <h2 class="alb-entry-title">2026安徽省养老博览会</h2>
        <h3 class="alb-entry-subtitle">图片直播通道</h3>
        <p class="alb-entry-desc">点击下方链接，获取展会现场精彩瞬间</p>
        <a href="#/" class="alb-entry-btn">
          <span class="alb-entry-play">▶</span>获取精彩瞬间
        </a>
      </div>
    </section>
  </div>
</template>

<script>
export default { name: 'CloudAlbum' };
</script>

<style scoped>
.alb-page {
  min-height: 100vh;
  background: #FFF4E6;
  padding-bottom: 120px;
}

/* ===== 顶部子导航（与云展览一致） ===== */
.sub-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 32px;
  background: #fff;
  border-bottom: 1px solid #F0E3D1;
}
.sub-nav-back {
  font-size: 15px;
  font-weight: 700;
  color: #E27A1D;
  text-decoration: none;
  letter-spacing: 0.5px;
}
.sub-nav-back:hover { opacity: 0.75; }
.sub-nav-title {
  font-family: var(--font-serif);
  font-size: 18px;
  font-weight: 900;
  color: var(--color-text);
}

/* ===== 头部（与云展览一致风格） ===== */
.alb-head {
  text-align: center;
  padding: 100px 32px 80px;
}
.alb-head-tag {
  display: inline-flex;
  align-items: center;
  gap: 18px;
  color: #D4680A;
  font-family: var(--font-serif);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 5px;
  margin-bottom: 20px;
}
.alb-head-line {
  display: inline-block;
  width: 36px;
  height: 1px;
  background: #E2A770;
}
.alb-head-title {
  font-family: var(--font-serif);
  font-size: clamp(44px, 7vw, 72px);
  font-weight: 900;
  color: #2B2420;
  margin: 0 0 18px;
  line-height: 1.1;
}
.alb-head-desc {
  font-size: 17px;
  line-height: 1.9;
  color: #6B5D54;
  margin: 0;
}

/* ===== 主卡（橙黄渐变） ===== */
.alb-body {
  padding: 0 32px;
}
.alb-entry {
  max-width: 1200px;
  margin: 0 auto;
  border-radius: 24px;
  background: linear-gradient(135deg, #D3742F 0%, #E2872E 35%, #EFA928 100%);
  padding: 110px 48px;
  text-align: center;
  color: #fff;
  box-shadow: 0 24px 60px rgba(226, 122, 29, 0.35);
  position: relative;
  overflow: hidden;
}
.alb-entry::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.18), transparent 55%);
  pointer-events: none;
}
.alb-entry-icon {
  font-size: 52px;
  margin-bottom: 28px;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.18));
  position: relative;
}
.alb-entry-title {
  font-family: var(--font-serif);
  font-size: clamp(32px, 4.5vw, 54px);
  font-weight: 900;
  margin: 0 0 12px;
  position: relative;
}
.alb-entry-subtitle {
  font-family: var(--font-serif);
  font-size: clamp(26px, 3.8vw, 44px);
  font-weight: 900;
  margin: 0 0 24px;
  position: relative;
}
.alb-entry-desc {
  font-size: 17px;
  opacity: 0.95;
  margin: 0 0 44px;
  line-height: 1.8;
  position: relative;
}
.alb-entry-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 18px 44px;
  background: #fff;
  color: #C25A2D;
  border-radius: 999px;
  font-size: 17px;
  font-weight: 800;
  text-decoration: none;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  position: relative;
}
.alb-entry-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.22);
}
.alb-entry-play {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, #E27A1D, #EFA928);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  padding-left: 3px;
}

@media (max-width: 820px) {
  .sub-nav { padding: 14px 20px; }
  .alb-head { padding: 64px 16px 48px; }
  .alb-body { padding: 0 16px; }
  .alb-entry { padding: 64px 20px; border-radius: 18px; }
  .alb-entry-icon { font-size: 40px; margin-bottom: 20px; }
  .alb-entry-btn { padding: 15px 32px; font-size: 15px; }
}
</style>
